import { c as _c } from "react/compiler-runtime";
import { DataFileInterface, FileSourceEnum } from '@systemeio/file-manager';
import { Checkbox, FormInput, FormInputNumber, cents } from '@systemeio/ui';
import { ProductVariantInterface } from 'modules/products/types/product-variant-interface';
import React from 'react';
import { ImageUploaderWithPreviewImage } from 'shared/components/file-uploader/image-uploader-with-preview-image';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useMediaQuery from 'shared/hooks/use-media-query';
import { twMerge } from 'tailwind-merge';
import { TrashIcon } from '@systemeio/ui/icons';
interface MobileVariantsTableProps {
  variants: ProductVariantInterface[];
  setVariants: React.Dispatch<React.SetStateAction<ProductVariantInterface[]>>;
  isDeleteAvailable: boolean | null;
  variantsImages: DataFileInterface[];
}
function MobileVariantsTable(t0) {
  const $ = _c(95);
  const {
    variants,
    setVariants,
    isDeleteAvailable
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    isSM
  } = useMediaQuery();
  let t1;
  if ($[0] !== setVariants) {
    t1 = variant => value => setVariants(prev => prev.map(v => v.id === variant.id ? {
      ...v,
      selected: value
    } : v));
    $[0] = setVariants;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChangeVariantSelect = t1;
  let t2;
  if ($[2] !== setVariants) {
    t2 = variantId => e => setVariants(prev_0 => prev_0.map(v_0 => v_0.id === variantId ? {
      ...v_0,
      sku: e.target.value
    } : v_0));
    $[2] = setVariants;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleChangeVariantSkuValue = t2;
  let t3;
  if ($[4] !== setVariants) {
    t3 = variantId_0 => e_0 => setVariants(prev_1 => prev_1.map(v_1 => v_1.id === variantId_0 ? {
      ...v_1,
      price: cents(e_0.target.value)
    } : v_1));
    $[4] = setVariants;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleChangeVariantPriceValue = t3;
  let t4;
  if ($[6] !== setVariants) {
    t4 = variantId_1 => stock => setVariants(prev_2 => prev_2.map(v_2 => v_2.id === variantId_1 ? {
      ...v_2,
      stock
    } : v_2));
    $[6] = setVariants;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleChangeVariantStock = t4;
  let t5;
  if ($[8] !== setVariants) {
    t5 = variantId_2 => image => setVariants(prev_3 => prev_3.map(v_3 => v_3.id === variantId_2 ? {
      ...v_3,
      image
    } : v_3));
    $[8] = setVariants;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const setVariantImage = t5;
  let t6;
  if ($[10] !== isDeleteAvailable) {
    t6 = variant_0 => {
      if (isDeleteAvailable !== null) {
        return isDeleteAvailable ? variant_0.deleted ? true : false : variant_0.deleted ? false : true;
      }
      return false;
    };
    $[10] = isDeleteAvailable;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const isDisabled = t6;
  let t7;
  if ($[12] !== setVariants) {
    t7 = variant_1 => e_1 => setVariants(prev_4 => prev_4.map(v_4 => v_4.id === variant_1.id ? {
      ...v_4,
      deleted: true
    } : v_4));
    $[12] = setVariants;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const handleMarkVariantAsDeleted = t7;
  const t8 = isSM && "w-auto";
  let t9;
  if ($[14] !== t8) {
    t9 = twMerge(t8);
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const baseColumnClassName = t9;
  const t10 = !isSM && "col-end-6";
  let t11;
  if ($[16] !== t10) {
    t11 = twMerge("col-start-1 mt-5 flex flex-col", t10);
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== handleChangeVariantSelect || $[19] !== isDisabled || $[20] !== setVariantImage || $[21] !== variants) {
    let t13;
    if ($[23] !== handleChangeVariantSelect || $[24] !== isDisabled || $[25] !== setVariantImage) {
      t13 = variant_2 => <div key={variant_2.id} className="my-2 flex h-[70px] items-center"><Checkbox onChange={handleChangeVariantSelect(variant_2)} value={variant_2?.selected ?? false} disabled={isDisabled(variant_2)} /><div className="mx-4"><ImageUploaderWithPreviewImage labelImageUploader="" aspectRatio={1} previewClassName="w-[60px] h-[60px]" value={variant_2.image} source={FileSourceEnum.Product} onSelect={setVariantImage(variant_2.id)} onRemove={() => setVariantImage(variant_2.id)(undefined)} /></div></div>;
      $[23] = handleChangeVariantSelect;
      $[24] = isDisabled;
      $[25] = setVariantImage;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    t12 = variants.map(t13);
    $[18] = handleChangeVariantSelect;
    $[19] = isDisabled;
    $[20] = setVariantImage;
    $[21] = variants;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12) {
    t13 = <div className={t11}>{t12}</div>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  const t14 = isSM && "col-start-3";
  let t15;
  if ($[30] !== t14) {
    t15 = twMerge(t14);
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t) {
    t16 = t("dashboard.products.variant.title");
    $[32] = t;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== variants) {
    t17 = variants.map(_temp2);
    $[34] = variants;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== baseColumnClassName || $[37] !== t16 || $[38] !== t17) {
    t18 = <VariantScrollableColumn title={t16} columnClassName={baseColumnClassName}>{t17}</VariantScrollableColumn>;
    $[36] = baseColumnClassName;
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t) {
    t19 = t("dashboard.products.sku.title");
    $[40] = t;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== handleChangeVariantSkuValue || $[43] !== variants) {
    let t21;
    if ($[45] !== handleChangeVariantSkuValue) {
      t21 = variant_4 => <div key={variant_4.id} className="mx-4 my-2 flex h-[70px] items-center"><FormInput value={variant_4.sku} placeholder="SKU" onChange={handleChangeVariantSkuValue(variant_4.id)} maxLength={256} disabled={variant_4.deleted} /></div>;
      $[45] = handleChangeVariantSkuValue;
      $[46] = t21;
    } else {
      t21 = $[46];
    }
    t20 = variants.map(t21);
    $[42] = handleChangeVariantSkuValue;
    $[43] = variants;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[47] !== baseColumnClassName || $[48] !== t19 || $[49] !== t20) {
    t21 = <VariantScrollableColumn title={t19} columnClassName={baseColumnClassName}>{t20}</VariantScrollableColumn>;
    $[47] = baseColumnClassName;
    $[48] = t19;
    $[49] = t20;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== t) {
    t22 = t("global.price");
    $[51] = t;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== handleChangeVariantPriceValue || $[54] !== variants) {
    let t24;
    if ($[56] !== handleChangeVariantPriceValue) {
      t24 = variant_5 => <div key={variant_5.id} className="my-2 flex h-[70px] items-center"><FormInput value={variant_5?.price} placeholder="Variant price" onChange={handleChangeVariantPriceValue(variant_5.id)} maxLength={256} disabled={variant_5.deleted} /></div>;
      $[56] = handleChangeVariantPriceValue;
      $[57] = t24;
    } else {
      t24 = $[57];
    }
    t23 = variants.map(t24);
    $[53] = handleChangeVariantPriceValue;
    $[54] = variants;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[58] !== baseColumnClassName || $[59] !== t22 || $[60] !== t23) {
    t24 = <VariantScrollableColumn title={t22} columnClassName={baseColumnClassName}>{t23}</VariantScrollableColumn>;
    $[58] = baseColumnClassName;
    $[59] = t22;
    $[60] = t23;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] !== t) {
    t25 = t("dashboard.products.stock.header");
    $[62] = t;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  let t26;
  if ($[64] !== handleChangeVariantStock || $[65] !== t || $[66] !== variants) {
    let t27;
    if ($[68] !== handleChangeVariantStock || $[69] !== t) {
      t27 = variant_6 => <div key={variant_6.id} className="my-2 flex h-[70px] items-center"><FormInputNumber value={variant_6?.stock || 0} placeholder={t("dashboard.products.variant_stock")} onChange={handleChangeVariantStock(variant_6.id)} disabled={variant_6.deleted} type="integer" /></div>;
      $[68] = handleChangeVariantStock;
      $[69] = t;
      $[70] = t27;
    } else {
      t27 = $[70];
    }
    t26 = variants.map(t27);
    $[64] = handleChangeVariantStock;
    $[65] = t;
    $[66] = variants;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  let t27;
  if ($[71] !== baseColumnClassName || $[72] !== t25 || $[73] !== t26) {
    t27 = <VariantScrollableColumn title={t25} columnClassName={baseColumnClassName}>{t26}</VariantScrollableColumn>;
    $[71] = baseColumnClassName;
    $[72] = t25;
    $[73] = t26;
    $[74] = t27;
  } else {
    t27 = $[74];
  }
  let t28;
  if ($[75] !== baseColumnClassName) {
    t28 = twMerge("mt-5 w-1/4", baseColumnClassName);
    $[75] = baseColumnClassName;
    $[76] = t28;
  } else {
    t28 = $[76];
  }
  let t29;
  if ($[77] !== handleMarkVariantAsDeleted || $[78] !== variants) {
    let t30;
    if ($[80] !== handleMarkVariantAsDeleted) {
      t30 = variant_7 => <div key={variant_7.id} className="my-2 ml-4 flex h-[70px] items-center">{!variant_7.deleted && <TrashIcon onClick={handleMarkVariantAsDeleted(variant_7)} />}</div>;
      $[80] = handleMarkVariantAsDeleted;
      $[81] = t30;
    } else {
      t30 = $[81];
    }
    t29 = variants.map(t30);
    $[77] = handleMarkVariantAsDeleted;
    $[78] = variants;
    $[79] = t29;
  } else {
    t29 = $[79];
  }
  let t30;
  if ($[82] !== t28 || $[83] !== t29) {
    t30 = <VariantScrollableColumn columnClassName={t28}>{t29}</VariantScrollableColumn>;
    $[82] = t28;
    $[83] = t29;
    $[84] = t30;
  } else {
    t30 = $[84];
  }
  let t31;
  if ($[85] !== t15 || $[86] !== t18 || $[87] !== t21 || $[88] !== t24 || $[89] !== t27 || $[90] !== t30) {
    t31 = <VariantScrollableContainer className={t15}>{t18}{t21}{t24}{t27}{t30}</VariantScrollableContainer>;
    $[85] = t15;
    $[86] = t18;
    $[87] = t21;
    $[88] = t24;
    $[89] = t27;
    $[90] = t30;
    $[91] = t31;
  } else {
    t31 = $[91];
  }
  let t32;
  if ($[92] !== t13 || $[93] !== t31) {
    t32 = <VariantTableContainer>{t13}{t31}</VariantTableContainer>;
    $[92] = t13;
    $[93] = t31;
    $[94] = t32;
  } else {
    t32 = $[94];
  }
  return t32;
}
function _temp2(variant_3) {
  return <div key={variant_3.id} className="my-2 flex h-[70px] items-center justify-evenly"><div className={`text-text-primary overflow-x-auto whitespace-nowrap text-xl ${variant_3.deleted && "line-through"}`}>{variant_3.productOptionValues?.map(_temp).join("/")}</div></div>;
}
function _temp(e_2) {
  return e_2.value;
}
export default MobileVariantsTable;
interface VariantColumnProps {
  title?: string;
  children: React.ReactNode;
  columnClassName?: string;
}
function VariantScrollableColumn(t0) {
  const $ = _c(8);
  const {
    title,
    children,
    columnClassName: t1
  } = t0;
  const columnClassName = t1 === undefined ? "" : t1;
  const t2 = `flex w-full shrink-0 justify-center ${columnClassName}`;
  let t3;
  if ($[0] !== title) {
    t3 = title && <div className="flex justify-center">{title}</div>;
    $[0] = title;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== t3) {
    t4 = <div className="mx-2 flex w-full flex-col">{t3}{children}</div>;
    $[2] = children;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <div className={t2}>{t4}</div>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
function VariantScrollableContainer(t0) {
  const $ = _c(7);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = twMerge("relative col-start-6 col-end-13 flex w-full flex-col overflow-auto overflow-x-scroll", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <div className="relative flex snap-mandatory scroll-smooth">{children}</div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function VariantTableContainer(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="flex"><div className="grid w-full grid-cols-12 gap-2">{children}</div></div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}